import api from '../api';

import { ParamsPaymentForms } from 'utils/typeServices';

type ParamsReponse = {
    Data: Array<ParamsPaymentForms>;
}

export const GetPaymentForms = async ({ token }: { token: string }) => {
    try {
        const { data } = await api.get<ParamsReponse>('v1/Plataforma/GetPlatformsWithPaymentForms', {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        });

        return { data: data.Data };
    } catch (error) {
        console.error('error', error);
        return { data: null };
    }
}
